import styled from "styled-components";

const ExpendedContainer = styled.div`
  display: flex;
  flex-direction: column; // row
  align-items: stretch;
  /* padding: 24px 60px 32px; */
  /* gap: 24px; */
`;

export { ExpendedContainer };
